import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

export const ReturnTable = ({ list }) => {
  return (
    <div className="table-responsive font-weight-bold">
      <table className="table table-bordered m-0 mb-4 border radius-remove all_domain_table">
        <thead className="text-white bg-gray-700">
          <tr>
            <th>Item ID/Order Id</th>
            <th>Customer</th>
            <th>Order Details</th>
            <th>Return Details</th>
            <th>Refund Amount</th>
          </tr>
        </thead>
        <tbody className="text-left">
          {list?.length > 0 ? (
            list?.map((dataList, index) => {
              return (
                <tr key={index.toString()}>
                  <td className="">
                    <Link
                      to={{
                        pathname: `/orderReturn/${dataList?.orderRefId}`,
                        state: {
                          orderRefId: dataList?.orderRefId,
                        },
                      }}
                    >
                      #{dataList?.orderRefId}
                    </Link>
                  </td>
                  <td className="" nowrap="nowrap">
                    {dataList?.customerName?.en} <br />
                    {dataList?.phoneNumber} <br />
                    {dataList?.email}
                  </td>
                  <td className="" nowrap="nowrap">
                    Order Date:{" "}
                    {dataList?.createdDate &&
                      moment(dataList?.createdDate).format("DD/MM/YYYY")}
                    <br />
                    Delivery Date:{" "}
                    {dataList?.deliveryDate &&
                      moment(dataList?.deliveryDate).format("DD/MM/YYYY")}
                    <br />
                    Payment Method: {dataList?.paymentMethod}
                  </td>

                  <td className="" nowrap="nowrap">
                    Return Id: {dataList?.returnId}
                    <br />
                    Return Requested On:{" "}
                    {dataList?.returnedRequestedDate &&
                      moment(dataList?.returnedRequestedDate).format(
                        "DD/MM/YYYY"
                      )}
                    <br />
                    Return Approved On:{" "}
                    {dataList?.returnApproveDate &&
                      moment(dataList?.returnApproveDate).format("DD/MM/YYYY")}
                    <br />
                  </td>

                  <td className="">Rs.{dataList?.refundValue}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={12} className="text-center">
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
